<template>
  <div class="near-fac">
    <h2 class="sub-heading">近隣の施設</h2>
    <div class="panel-thumb-wrapper">
      <kcs-facility-list-item
        v-for="(facility, index) in facilities"
        :key="index"
        :facility="facility"
      />
    </div>
  </div>
</template>

<script>
import KcsFacilityListItem from '@/components/molecules/kcs-facility-list-item.vue'
export default {
  components: {
    KcsFacilityListItem
  },
  props: {
    facilities: {
      type: Array,
      required: true
    }
  }
}
</script>
